module.exports = __webpack_public_path__ + "static/media/arrow-right.b7fe366d.svg";